import { connect } from 'react-redux';

import * as drawerTypes from 'types/drawer';
import { closeDrawer } from 'actions/drawer';

import Drawer from './index';

const mapDispatchToProps = dispatch => ({
    onClose: () => dispatch(closeDrawer(drawerTypes.DRAWER_SEARCH)),
});

export default connect(null, mapDispatchToProps)(Drawer);
